import React from 'react'
import clsx from 'clsx'
import { isEmpty, isNil } from 'ramda'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, CardMedia } from '@material-ui/core'

import { TYPE_POLL } from 'app/constants/messageType'

import PlainText from 'app/componentV4/PlainText'

const useStyles = makeStyles({
  root: {
    width: '25vw',
  },
  title: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    'line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  body: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    'line-clamp': 3,
    '-webkit-box-orient': 'vertical',
  },
})

const PreviewBody = (props) => {
  const { data, className = '' } = props
  const classes = useStyles()

  const RenderEmpty = () => {
    if (data.type === TYPE_POLL) return
    else
      return (
        <Typography className={'text-14 text-neutrals-600 font-normal'}>
          -
        </Typography>
      )
  }

  return (
    <div className={className}>
      {/* Title */}
      {isEmpty(data.translation.title) ? (
        <RenderEmpty />
      ) : (
        <Typography
          className={clsx(classes.title, 'text-14 text-primary font-bold')}
        >
          <PlainText text={data.translation.title} />
        </Typography>
      )}

      {/* Image */}
      {isNil(data.defaultImageUrl) ? null : (
        <CardMedia
          component="img"
          image={data.defaultImageUrl}
          // title="Image Preview Message"
          className="object-cover preview-image"
        />
      )}

      {/* Body */}
      {isEmpty(data.translation.descriptionPreview) ? (
        <RenderEmpty />
      ) : (
        <Typography
          className={clsx(classes.body, 'text-14 text-primary font-normal')}
        >
          <PlainText text={data.translation.descriptionPreview} />
        </Typography>
      )}
    </div>
  )
}

const dataPropTypes = {
  id: PropTypes.number,
  type: PropTypes.number,
  isScheduled: PropTypes.bool,
  isDraft: PropTypes.bool,
  isReminder: PropTypes.bool,
  translation: PropTypes.shape({
    title: PropTypes.string,
    descriptionPreview: PropTypes.string,
    body: PropTypes.string,
    languageId: PropTypes.number,
    languageCode: PropTypes.string,
  }),
  defaultImageUrl: PropTypes.string,
  scheduleCanceledDate: PropTypes.string,
  expirationDate: PropTypes.string,
  event: PropTypes.shape({
    status: PropTypes.number,
    endDate: PropTypes.string,
    startDate: PropTypes.string,
    endTimeZone: PropTypes.string,
    startTimeZone: PropTypes.string,
  }),
}
PreviewBody.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape(dataPropTypes).isRequired,
}

export default PreviewBody
